<script>
	export let notebook;
    export let link_title = false;
</script>


<div>
    {#if link_title}
        <a href="/notebook/{notebook.id}"><h1>{notebook.name}</h1></a>
    {:else}
        <h1>{notebook.name}</h1>
    {/if}

    <div>
    {#each Object.entries(notebook.organized_entries) as [section, categorized_entries] }
        {#if section != "0000"}
            <h2>{section}</h2>
            <hr>
        {/if}
        <div class="notebook">
        {#each Object.entries(categorized_entries) as [category, entries] }
            <div>
                <h3>{category}</h3>
                {#each entries as entry }
                    <a href="/notebook/{notebook.id}/{entry.id}"><h3>{entry.name}</h3></a>
                {/each}
            </div>
        {/each}
        </div>
    {/each}
    </div>

</div>


<style>
div.notebook {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
}
</style>
